import { render } from "./App.vue?vue&type=template&id=fb2dad80"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fb2dad80&lang=css"

import exportComponent from "D:\\Projects\\learning-center\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__